/**
 * Shake&Go — Shopify Cart API bridge.
 * Uses the real variant IDs injected by sections/shakego-product.liquid.
 */
(() => {
  "use strict";

  const commerce = window.ShakegoCommerce || {};
  const strings = commerce.strings || {};
  let pending = false;

  function setCount(count) {
    document.querySelectorAll("[data-cart-count], [data-cart-count-inline]").forEach((el) => {
      el.textContent = String(count || 0);
    });
    document.querySelectorAll("[data-cart-open]").forEach((button) => {
      button.setAttribute("aria-label", count ? `Abrir carrito, ${count} unidades` : "Abrir carrito, vacío");
    });
  }

  function setButtonsLoading(loading) {
    document.querySelectorAll("[data-add-to-cart]").forEach((button) => {
      button.disabled = loading;
      button.setAttribute("aria-busy", String(loading));
      if (loading) {
        button.dataset.previousText = button.textContent;
        button.textContent = strings.adding || "Agregando…";
      } else if (button.dataset.previousText) {
        button.textContent = button.dataset.previousText;
        delete button.dataset.previousText;
      }
    });
  }

  async function refreshCount() {
    const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    });
    if (!response.ok) return;
    const cart = await response.json();
    setCount(cart.item_count);
  }

  async function add(payload) {
    if (pending || !payload) return;
    if (!payload.variantId || payload.available === false) {
      window.alert(strings.error || "Esta variante no está disponible.");
      return;
    }

    pending = true;
    setButtonsLoading(true);
    const properties = payload.mode === "mixed"
      ? {
          "Composición Vainilla": String(payload.composition?.vainilla || 0),
          "Composición Chocolate": String(payload.composition?.chocolate || 0),
          "Composición Café": String(payload.composition?.cafe || 0),
        }
      : undefined;

    try {
      const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        credentials: "same-origin",
        body: JSON.stringify({ id: Number(payload.variantId), quantity: 1, properties }),
      });
      const data = await response.json().catch(() => ({}));
      if (!response.ok) throw new Error(data.description || data.message || strings.error || "No se pudo agregar al carrito.");
      await refreshCount();
      document.querySelectorAll("[data-add-to-cart]").forEach((button) => {
        button.textContent = strings.added || "Agregado al carrito";
      });
      window.setTimeout(() => {
        window.location.assign(commerce.cartUrl || `${window.Shopify?.routes?.root || "/"}cart`);
      }, 350);
    } catch (error) {
      window.alert(error.message || strings.error || "No se pudo agregar al carrito.");
    } finally {
      pending = false;
      setButtonsLoading(false);
    }
  }

  function bind() {
    refreshCount().catch(() => {});
    document.addEventListener("click", (event) => {
      const cartButton = event.target.closest("[data-cart-open]");
      if (!cartButton) return;
      event.preventDefault();
      window.location.assign(commerce.cartUrl || `${window.Shopify?.routes?.root || "/"}cart`);
    });
    window.addEventListener("shakego:addtocart", (event) => add(event.detail));
  }

  window.ShakegoCart = { add, refreshCount };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", bind, { once: true });
  else bind();
})();
